import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    pageHeader: {},
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(4),
    },
    pageContent: {
      maxWidth: 1080,
      margin: '0 auto',
    },
    section: {
      marginBottom: theme.spacing(5),
    },
    sectionHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
    },
    sectionTitle: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    dateRange: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    dateInput: {
      '& .MuiOutlinedInput-input': {
        padding: '6px 12px',
        fontSize: theme.typography.pxToRem(13),
      },
    },
    dateSeparator: {
      fontSize: theme.typography.pxToRem(13),
      color: theme.palette.text.secondary,
    },
    kpiGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: theme.spacing(2),
    },
    chartsContainer: {
      position: 'relative' as const,
    },
    chartsOverlay: {
      position: 'absolute' as const,
      inset: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      zIndex: 1,
      borderRadius: theme.shape.borderRadius,
    },
    chartsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: theme.spacing(3),
    },
    fullWidthChart: {
      gridColumn: '1 / -1',
    },
    loader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 400,
    },
    error: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
      color: theme.palette.error.main,
    },
  }),
  { name: 'UsageReportDashboard' }
);
